import { HANDOVER_DAY_RULE_LABEL, type HandoverDayRule } from "./enums";
import { handoverDayLabel } from "./dates";

// The refusals for a restricted drop-off and collection day (handover-days),
// written once: the card says them before the round trip, and the route says
// them if a request gets past the card. Two copies of a sentence drift.

/** AC3 — the row a new one runs into, named as the list names it. */
export function handoverOverlapMessage(day: { startsOn: string; endsOn: string; rule: HandoverDayRule }): string {
  return `That runs into ${handoverDayLabel(day)} (${HANDOVER_DAY_RULE_LABEL[day.rule].toLowerCase()}). Remove that row first, or pick other days.`;
}

/** AC4 — a first day before today. A customer cannot ask for yesterday. */
export function handoverPassedMessage(startsOn: string): string {
  return `${handoverDayLabel({ startsOn, endsOn: startsOn })} has passed.`;
}

/** AC4 — a range that ends before it starts. */
export const HANDOVER_REVERSED_MESSAGE = "The last day is before the first.";
